import script from "./CardBaseConhecimentos.vue?vue&type=script&setup=true&lang=js"
export * from "./CardBaseConhecimentos.vue?vue&type=script&setup=true&lang=js"

import "./CardBaseConhecimentos.vue?vue&type=style&index=0&id=f41c99e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f41c99e0"]])

export default __exports__